import { Box, BoxProps } from '@mui/material';
import React from 'react';
import { useServerTranslation } from 'hooks/useServerTranslation';
import Price from '../../Price';

type TotalsType = BoxProps & {
    totals: {
        label: string;
        type: 'total' | 'subtotal' | 'shipping' | 'vat' | string;
        translate: boolean;
        value: number;
    }[];
};

export default function Totals(props: TotalsType) {
    const { totals, ...boxProps } = props;

    const { t } = useServerTranslation();

    return (
        <Box {...boxProps}>
            {totals.map((item, index) => (
                <Box key={index} display="flex">
                    <Box width="100%">{t(item.label)}</Box>
                    {' '}
                    <Price price={item.value} size={1} />
                </Box>
            ))}
        </Box>
    );
}
